import { useApp } from "@/contexts/AppContext";

export default function LanguagePills({ value, onChange, className = "" }) {
  const ctx = useApp();
  const v = value !== undefined ? value : ctx.language;
  const setter = onChange || ctx.setLanguage;
  const all = [{ name: "All" }, ...ctx.languages];

  return (
    <div className={`flex items-center gap-2 overflow-x-auto no-scrollbar ${className}`} data-testid="language-pills">
      {all.map((l) => (
        <button
          key={l.name}
          data-testid={`lang-pill-${l.name}`}
          onClick={() => setter(l.name)}
          className={`pill whitespace-nowrap ${v === l.name ? "pill-active" : "hover:bg-muted"}`}
        >
          {l.name}
        </button>
      ))}
    </div>
  );
}
